import types from '../mutation-types';
import CompanyNotesAPI from '../../api/companyNotes';
import camelcaseKeys from 'camelcase-keys';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAllNotesByCompany: _state => companyId => {
    const records = _state.records[companyId] || [];
    return records.sort((r1, r2) => r2.id - r1.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllNotesByCompanyId: _state => companyId => {
    const records = _state.records[companyId] || [];
    const companyNotes = records.sort((r1, r2) => r2.id - r1.id);
    return camelcaseKeys(companyNotes);
  },
};

export const actions = {
  async get({ commit }, { companyId }) {
    commit(types.SET_COMPANY_NOTES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await CompanyNotesAPI.get(companyId);
      commit(types.SET_COMPANY_NOTES, { companyId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPANY_NOTES_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { companyId, content }) {
    commit(types.SET_COMPANY_NOTES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await CompanyNotesAPI.create(companyId, content);
      commit(types.ADD_COMPANY_NOTE, { companyId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPANY_NOTES_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { companyId, noteId, content }) {
    commit(types.SET_COMPANY_NOTES_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await CompanyNotesAPI.update(companyId, noteId, content);
      commit(types.EDIT_COMPANY_NOTE, { companyId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPANY_NOTES_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, { noteId, companyId }) {
    commit(types.SET_COMPANY_NOTES_UI_FLAG, { isDeleting: true });
    try {
      await CompanyNotesAPI.delete(companyId, noteId);
      commit(types.DELETE_COMPANY_NOTE, { companyId, noteId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPANY_NOTES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_COMPANY_NOTES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_COMPANY_NOTES]($state, { data, companyId }) {
    $state.records = {
      ...$state.records,
      [companyId]: data,
    };
  },
  [types.ADD_COMPANY_NOTE]($state, { data, companyId }) {
    const companyNotes = $state.records[companyId] || [];
    $state.records[companyId] = [...companyNotes, data];
  },
  [types.EDIT_COMPANY_NOTE]($state, { data, companyId }) {
    const companyNotes = $state.records[companyId] || [];
    const noteIndex = companyNotes.findIndex(note => note.id === data.id);
    if (noteIndex !== -1) {
      companyNotes[noteIndex] = data;
      $state.records[companyId] = [...companyNotes];
    }
  },
  [types.DELETE_COMPANY_NOTE]($state, { noteId, companyId }) {
    const companyNotes = $state.records[companyId];
    const withoutDeletedNote = companyNotes.filter(note => note.id !== noteId);
    $state.records[companyId] = [...withoutDeletedNote];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
